var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head_comber"},[_c('div',{staticClass:"breadcrum warp"},[_c('a',{attrs:{"href":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('span',[_vm._v(">")]),_vm._v(" "),_c('router-link',{attrs:{"target":"li","to":"/supply_demand"}},[_vm._v("供需平台")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6699ea5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/enterTitle.vue
// module id = 4Udc
// module chunks = 1